import { ReactComponent as HeadphonesGradient } from 'assets/icons/headphones-gradient.svg';

export default HeadphonesGradient;
